const initialState = {
  data: '',
};

const shareReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DATA':
      return {
        ...state,
        data: action.payload,
      };
    case 'SHARE_DATA':
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
export default shareReducer;